<template src="./template.html"></template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import { changeBool } from '@/helper'
  import api from '@/api'
  import UserItems from './UserItems'
  import UserPagination from '@/components/modules/user/UserPagination'
  import MultiSelectInput from '@/components/ui/MultiSelectInput'

  export default {
    name: 'ManageGroupsOverlay',
    components: {
      MultiSelectInput,
      UserPagination,
      UserItems,
    },
    props: {
      isOpen: Boolean,
      group: Object,
    },
    data() {
      return {
        isPending: false,
        page: 1,
        userList: [],
        selectedTab: null,
        selectedUsers: null,
        tabs: [
          'all',
          'admins',
          'invitations',
          'invitations-decline',
        ],
        users: {},
        usersPerPage: 0,
      }
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
      selectedUserIds() {
        return this.selectedUsers ? this.selectedUsers.map(u => u = u.id) : []
      },
      options() {
        return {
          page: this.page,
          per_page: this.usersPerPage,
        }
      },
    },
    watch: {
      selectedTab(type) {
        this.userList = []
        this.selectedUsers = null
        this.users = {}
        this.page = 1
        this.getGroupUsers(Object.assign(this.options, { type }))
        return true
      },
    },
    created() {
      this.usersPerPage = isMobile ? 3 : 9
      this.selectedTab = 'all'
    },
    methods: {
      onPaginate(page) {
        const options = {
          page,
          per_page: this.usersPerPage,
        }
        this.filterGroupUsers(Object.assign(options, { filter: this.selectedUserIds, type: this.selectedTab }))
      },
      onSearch(search) {
        // if (this.selectedTab === 'invitations') {
        //   this.searchUsers(search)
        //   return true
        // }
        this.searchGroupUsers({ search, type: this.selectedTab })
      },
      onResetFilter() {
        this.selectedUsers = null
        this.filterGroupUsers(Object.assign(this.options, { filter: this.selectedUserIds, type: this.selectedTab }))
      },
      onSubmitSearch() {
        this.page = 1
        switch (this.selectedTab) {
          case 'all':
            this.filterGroupUsers(Object.assign(this.options, { filter: this.selectedUserIds, type: this.selectedTab }))
            break
          case 'admins':
            api.items.createItem(`groups/${this.group.id}/admins`, { users: this.selectedUserIds }).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          case 'invitations':
            api.items.createItem(`groups/${this.group.id}/invitations`, { users: this.selectedUserIds }).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          case 'invitations-decline':
            api.groups.resendInvitations(this.group.id, { users: this.selectedUserIds }).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          default:
            break
        }
      },
      onResultsUpdate(args) {
        this.selectedUsers = args
      },
      async getGroupUsers(options) {
        changeBool(this, 'isPending')
        api.items.getItems(`groups/${this.group.id}/users`, options).then(({ data }) => {
          this.users = data
          changeBool(this, 'isPending')
        })
      },
      async filterGroupUsers(options) {
        changeBool(this, 'isPending')
        api.items.filterItems(`groups/${this.group.id}/users`, options).then(({ data }) => {
          this.users = data
          this.page = data.pagination.self
          changeBool(this, 'isPending')
        })
      },
      searchGroupUsers(options) {
        changeBool(this, 'isPending')
        api.items.searchItems(`groups/${this.group.id}/users/search`, options).then(({ data }) => {
          this.userList = data
          changeBool(this, 'isPending')
        })
      },
      // async searchUsers(val) {
      //   changeBool(this, 'isPending')
      //   api.users.searchUser(val).then(({ data }) => {
      //     this.userList = data
      //     changeBool(this, 'isPending')
      //   })
      // },
      onRemove(member) {
        switch (this.selectedTab) {
          case 'all':
            api.groups.removeMember(this.group.id, member.id).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          case 'admins':
            api.groups.removeAdmin(this.group.id, member.id).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          case 'invitations':
            api.groups.removeInvitation(this.group.id, member.id).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          case 'invitations-decline':
            api.groups.removeInvitationDecline(this.group.id, member.id).then(_ => {
              this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
            })
            break
          default:
            break
        }
      },
      onResend(member) {
        if (this.selectedTab === 'invitations-decline') {
          api.groups.resendInvitation(this.group.id, member.id).then(_ => {
            this.filterGroupUsers(Object.assign(this.options, { type: this.selectedTab }))
          })
        }
      },
    },
  }
</script>
